import { createFileRoute } from "@tanstack/react-router"
import { projectFormDetailViewStaticData } from "src/views/ProjectFormDetailView/constants"
import { ProjectFormDetailView } from "src/views/ProjectFormDetailView/ProjectFormDetailView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/$formId/")({
	component: ProjectFormDetailView,
	staticData: projectFormDetailViewStaticData,
})
